import { useState } from 'react';

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      quote: "Master Jae Production transformed my sound completely. The attention to detail in mixing and mastering is unmatched. My tracks have never sounded this professional!",
      author: "Thabo Mokoena",
      role: "Hip-Hop Artist",
      image: "https://public.readdy.ai/ai/img_res/99f85e682af3e17d8099f61ae2edf283.jpg"
    },
    {
      quote: "The graphic design work exceeded all expectations. They captured our brand essence perfectly and delivered stunning visuals that truly represent who we are.",
      author: "Lerato Dlamini",
      role: "Business Owner",
      image: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20confident%20African%20female%20entrepreneur%20in%20business%20casual%20attire%2C%20warm%20natural%20lighting%2C%20authentic%20smile%2C%20modern%20professional%20headshot%2C%20approachable%20demeanor&width=200&height=200&seq=testimonial-002&orientation=squarish"
    },
    {
      quote: "Working with Master Jae on our podcast has been incredible. The audio quality is crystal clear, and their post-production skills brought our content to life.",
      author: "Sipho Khumalo",
      role: "Podcast Host",
      image: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20African%20male%20podcast%20host%20with%20headphones%2C%20casual%20creative%20style%2C%20warm%20studio%20lighting%2C%20genuine%20smile%2C%20modern%20content%20creator%20headshot&width=200&height=200&seq=testimonial-003&orientation=squarish"
    },
    {
      quote: "From concept to final product, the team delivered excellence. Their creativity and professionalism made the entire process smooth and enjoyable.",
      author: "Nomsa Radebe",
      role: "Marketing Director",
      image: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20sophisticated%20African%20female%20marketing%20executive%20in%20professional%20attire%2C%20confident%20expression%2C%20modern%20office%20lighting%2C%20polished%20professional%20headshot&width=200&height=200&seq=testimonial-004&orientation=squarish"
    }
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-24 px-6 bg-[#0f0f0f]">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-12 gap-12 items-center">
          {/* Left Side - Quote Mark */}
          <div className="md:col-span-4">
            <div className="text-[#00d9ff] opacity-20">
              <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M40 120C40 93.5 52.5 72.5 77.5 57.5L85 67.5C70 77.5 62.5 90 62.5 105C67.5 102.5 72.5 101.25 77.5 101.25C92.5 101.25 105 113.75 105 128.75C105 143.75 92.5 156.25 77.5 156.25C62.5 156.25 40 143.75 40 120ZM115 120C115 93.5 127.5 72.5 152.5 57.5L160 67.5C145 77.5 137.5 90 137.5 105C142.5 102.5 147.5 101.25 152.5 101.25C167.5 101.25 180 113.75 180 128.75C180 143.75 167.5 156.25 152.5 156.25C137.5 156.25 115 143.75 115 120Z" fill="currentColor" stroke="currentColor" strokeWidth="2"/>
              </svg>
            </div>
          </div>

          {/* Right Side - Testimonial Content */}
          <div className="md:col-span-8">
            <div className="border-l-4 border-[#00d9ff] pl-8">
              <p className="text-white text-2xl md:text-3xl italic leading-relaxed mb-8">
                "{testimonials[currentIndex].quote}"
              </p>

              <div className="flex items-center space-x-4 mb-8">
                <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0">
                  <img 
                    src={testimonials[currentIndex].image}
                    alt={testimonials[currentIndex].author}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="text-white text-xl font-bold">— {testimonials[currentIndex].author}</div>
                  <div className="text-gray-400">{testimonials[currentIndex].role}</div>
                </div>
              </div>

              {/* Navigation Controls */}
              <div className="flex items-center space-x-4">
                <button 
                  onClick={prevTestimonial}
                  className="w-12 h-12 rounded-full border-2 border-gray-600 text-gray-400 hover:border-[#00d9ff] hover:text-[#00d9ff] transition-all duration-300 flex items-center justify-center cursor-pointer"
                >
                  <i className="ri-arrow-left-line text-xl"></i>
                </button>
                <button 
                  onClick={nextTestimonial}
                  className="w-12 h-12 rounded-full bg-[#00d9ff] text-black hover:bg-[#00f0ff] transition-all duration-300 flex items-center justify-center cursor-pointer"
                >
                  <i className="ri-arrow-right-line text-xl"></i>
                </button>
                <div className="text-gray-400 ml-4">
                  {currentIndex + 1} / {testimonials.length}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
